// consts/enums
import { INTERNAL_NAMESPACE } from './appActionNamespaces';

export const INTERNAL_UPDATE_PREV_OFFER_FULL_PAYLOAD = `${INTERNAL_NAMESPACE}/UPDATE_PREV_OFFER_FULL_PAYLOAD`;
export const INTERNAL_PATCH_PREV_OFFER_PAYLOAD_MENU_PRODUCTS = `${INTERNAL_NAMESPACE}/PATCH_PREV_OFFER_PAYLOAD_MENU_PRODUCTS`;
export const INTERNAL_UPDATE_PREV_OFFER_AFTER_INIT = `${INTERNAL_NAMESPACE}/UPDATE_PREV_OFFER_AFTER_INIT`;
